import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import dropdownIcon from '../../images/svg/dropdownIcon.svg'
import searchIcon from '../../images/svg/searchIcon.svg'
import api from '../../services/api'
import 'animate.css';
import { SidebarContext } from '../../context/sidebar'



const HeaderSecondary = () => {

    const {handleSidebar} = useContext(SidebarContext)

    const [products, setProducts] = useState([])
    const [name, setName] = useState()
    const [search, setSearch] = useState(false)
    const [categorys,setCategorys] = useState([])



    const navigate = useNavigate()

    const redirectToHomePage = () => {
        navigate("/")
    }

    const redirectToAcessoriePage = () => {
        navigate("/accessories")
    }

    const redirectToBlogPage = () => {
        navigate("/blog")
    }

    const redirectToOfferPage = () => {
        navigate("/offer")

    }

    const redirectToProductPage = async (id, description, price, image, name, promotion_price) => {
            localStorage.setItem("@NAME", name)
            localStorage.setItem("@DESCRIPTION", description)
            localStorage.setItem("@PRICE", price)
            localStorage.setItem("@PROMOTIONAL_PRICE", promotion_price)
            navigate(`/product?id=${id}`)
        
    }

    const getProducts = async () => {

        const response = await api.get(`/client/get/product/by/name/${name}`)
        if (response.status == 200) {
            setProducts(response.data)
            return false
        }

        if (response.status == 404) {
            setProducts([])
        }

    }
    const getAllCategorys = async () => {
        const response = await api.get("/client/get/all/categorys/menu")
        if(response.status == 200){
            setCategorys(response.data)
            return false
        }

        setCategorys([])



    }
    const hanldeOnblurInput = () => {

        setTimeout(() => {
            setSearch(false)
        }, [1000])

    }

    useEffect(() => {
        if (name !== undefined && name !== "") {
            // Você pode colocar qualquer lógica que queira executar quando name não for indefinido ou vazio
            return;
        } else {
            const timer = setTimeout(() => {
                setSearch(false);
            }, 5000);

            return () => clearTimeout(timer); // Função de limpeza para limpar o timeout
        }
    }, [search, name]);


    useEffect(() => {

        getProducts()

    }, [name])

    useEffect(() => {

        getAllCategorys()
    },[])

    return (

        <div className="container_header_secondary">


            <div className='box_header_secondary'>

                <div class="dropdown">
                    <button class="btn_dropdow "  type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                    <img src={dropdownIcon} />
                        Categorias
                    </button>
                    <ul class="dropdown-menu"  aria-labelledby="dropdownMenuButton1">
                        {categorys?.map(item => {
                            return(
                                <li><a class="dropdown-item" onClick={() => {handleSidebar(true,item.name);localStorage.setItem("@LAST_CATEGORY",item.name)}}>{item.name}</a></li>

                            )
                        })}
                    </ul>
                </div>


                {search == true

                    ?

                    <div className='container_search_header'>

                        {name

                            ?

                            <div className='bottom_search_header'>
                                {
                                    products?.map(item => {
                                        return (
                                            <div onClick={() => redirectToProductPage(item.product_id, item.description, item.price, item.product_image, item.name, item.promotion_price)} className='container_product_bottom_search_header animate__animated animate__fadeIn'>
                                                <img src={item.product_image} />
                                                <div>
                                                    <p>{item.name}  </p>
                                                    <p><s>R$ {Number(item.promotion_price).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</s></p>
                                                    <p>R$ {Number(item.price).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</p>

                                                </div>
                                            </div>

                                        )
                                    })
                                }

                            </div>

                            :
                            <></>
                        }



                    </div>

                    :
                    <nav>
                        <ul>
                            <li className='li_header_secondary' onClick={() => redirectToHomePage()} >Home</li>
                            <li className='li_header_secondary' onClick={() => {handleSidebar(true,"Acessórios");window.location.href=`/products/page/?category=Acessórios&category_id=Acessórios`}}>Acessórios</li>
                            <li className='li_header_secondary' id="check_header_secondary" onClick={() =>  {handleSidebar(true,"Ofertas");localStorage.setItem("@LAST_CATEGORY","Ofertas");window.location.href=`/products/page/?category=Ofertas&category_id=Ofertas`}}>Ofertas</li>
                            <li className='li_header_secondary' onClick={() => {handleSidebar(true,"Engates Removíveis");localStorage.setItem("@LAST_CATEGORY","Engates Removíveis");window.location.href=`/products/page/?category=Engates Removíveis&category_id=Engates Removíveis`}}>Engates Removíveis</li>
                            <li className='li_header_secondary' onClick={() => {handleSidebar(true,"Engates Fixo");localStorage.setItem("@LAST_CATEGORY","Engates Fixo");window.location.href=`/products/page/?category=Engates Fixo&category_id=Engates Fixo`}}>Engates Fixos</li>
                            <li className='li_header_secondary' onClick={() => {handleSidebar(true,"Capotas Maritimas");localStorage.setItem("@LAST_CATEGORY","Capotas Maritimas");window.location.href=`/products/page/?category=Capotas Maritimas&category_id=Capotas Maritimas`}}>Capotas Maritimas</li>

                        </ul>
                    </nav>
                }




                <div className='header_search' >


                    <div onClick={() => setSearch(true)} style={{ width: search == true ? "980px" : "" }} className='search_item_space'>
                        <img src={searchIcon} onClick={() => setSearch(true)} />
                        {search == true

                            ?
                            <input type='text' autoFocus onBlur={() => hanldeOnblurInput()} onChange={(e) => setName(e.target.value)} placeholder='Pesquise aqui...' />

                            :
                            <></>
                        }

                    </div>

                    <div onClick={() => setSearch(true)} style={{ width: search == true ? "100%" : "" }} className='search_item_space_mobile'>
                        <img src={searchIcon} onClick={() => setSearch(true)} />
                        <p></p>
                    </div>


                </div>


                {search == true

                    ?
                    <input type='text' className='bottom_input_mobile_search' autoFocus onBlur={() => hanldeOnblurInput()} onChange={(e) => setName(e.target.value)} placeholder='Pesquise aqui...' />

                    :
                    <></>
                }


                {name && search == true

                    ?

                    <div className='bottom_search_header_mobile'>
                        {
                            products?.map(item => {
                                return (
                                    <div onClick={() => redirectToProductPage(item.product_id, item.description, item.price, item.product_image, item.name, item.promotion_price)} className='container_product_bottom_search_header animate__animated animate__fadeIn'>
                                        <img src={item.product_image} />
                                        <div>
                                            <p>{item.name}  </p>
                                            <p><s>R$ {Number(item.promotion_price).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</s></p>
                                            <p>R$ {Number(item.price).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</p>

                                        </div>
                                    </div>

                                )
                            })
                        }

                    </div>

                    :
                    <></>
                }


            </div>

        </div>

    )
}

export default HeaderSecondary